<template>
	<div class="text-input-wrapper" :class="input.class">
		<div class="date-input-wrapper">
			<div>
				<input
					type="text"
					pattern="[0-9]*"
					inputmode="numeric"
					v-model="month"
					:class="{
				'error': !isValid,
				'success': isValid,
				'uppercase': this.input.textTransform == 'uppecase',
				'lowercase': this.input.textTransform == 'lowercase'
				}"
					:name="input.name+'-month'"
					:maxlength="2"
					placeholder="MM"
					:id="input.name+'-mm'"
					@mouseup="selectAll($event)"
					@blur="[updateValidationStatus(), validateInput(), textTransform()]"
				/>
				<label :for="input.name+'-mm'">MM</label>
			</div>
			<div>
				<input
					type="text"
					pattern="[0-9]*"
					inputmode="numeric"
					v-model="day"
					:class="{
				'error': !isValid,
				'success': isValid,
				'uppercase': this.input.textTransform == 'uppecase',
				'lowercase': this.input.textTransform == 'lowercase'
				}"
					:name="input.name+'-day'"
					:maxlength="2"
					placeholder="DD"
					:id="input.name+'-dd'"
					@mouseup="selectAll($event)"
					@blur="[updateValidationStatus(), validateInput(), textTransform()]"
				/>
				<label :for="input.name+'-dd'">DD</label>
			</div>
			<div>
				<input
					type="text"
					pattern="[0-9]*"
					inputmode="numeric"
					v-model="year"
					:class="{
				'error': !isValid,
				'success': isValid,
				'uppercase': this.input.textTransform == 'uppecase',
				'lowercase': this.input.textTransform == 'lowercase'
				}"
					:name="input.name+'-year'"
					:maxlength="2"
					placeholder="YY"
					:id="input.name+'-yy'"
					@mouseup="selectAll($event)"
					@blur="[updateValidationStatus(), validateInput(), textTransform()]"
				/>
				<label :for="input.name+'-yy'">YY</label>
			</div>
		</div>
		<span class="price" v-if="input.price > 0" v-text="formatPrice(input.price)"></span>
		<div class="error-message" v-if="this.errorMessage">{{this.errorMessage}}</div>
	</div>
</template>

<script>
import InputText from "./InputText";

export default {
	name: "InputDate",
	extends: InputText,
	props: ["option"],
	data: function() {
		return {
			input: this.option.input,
			errorMessage: "",
			month: "",
			day: "",
			year: ""
		};
	},
	watch: {
		dateValue: function() {
			this.value = this.dateValue;
			this.saveToStore();
		}
	},
	created: function() {
		// Save default value to store
		if (this.value) {
			const datePart = this.value.split('.');
			this.month = datePart[0];
			this.day = datePart[1];
			this.year = datePart[2];
			this.saveToStore();
		}
		// Save default validation status to store
		this.updateValidationStatus();
	},
	computed: {
		dateValue() {
			return this.month+"."+this.day+"."+this.year;
		}
	}
};
</script>

<style lang="scss">
.date-input-wrapper {
	display: flex;
	justify-content: center;
	> div {
		text-align: center;
		margin: 0 8px;
		max-width: 80px;

		label {
			display: block;
			font-weight: bold;
			margin: 8px 0;
		}
	}
	+ .price {
		display: block;
		margin: 16px 0;
	}
}
</style>